import React, { useState,useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Vinayaka.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import { Link } from 'react-router-dom';
import axios from 'axios';
import city from '../../../city.json'



const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};




const Vinayaka = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [vinayakList, setVinayakList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedVinayaka, setSelectedVinayaka] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const vinayakaChaturthiTooltips = {
  "Vinayaka Chaturthi": "Vinayaka Chaturthi is a festival celebrating Lord Ganesha, observed on the fourth day (Chaturthi) of the lunar fortnight. Devotees perform puja, observe fasts, and seek blessings for prosperity, wisdom, and the removal of obstacles.",
  "Ganesha Jayanti, Vinayaka Chaturthi": "Ganesha Jayanti marks the birth of Lord Ganesha and coincides with Vinayaka Chaturthi in some months. Devotees celebrate with special rituals, prayers, and offerings to invoke divine blessings.",
  "Ganesh Chaturthi, Vinayaka Chaturthi": "Ganesh Chaturthi is the major festival of Lord Ganesha, observed with elaborate pujas and festivities. It coincides with Vinayaka Chaturthi, and devotees perform special prayers, fasts, and processions to honor the deity."
};


useEffect(() => {
  const fetchVinayakData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/vinayaka?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.vinayakaChaturthi) {
        setVinayakList(response.data.vinayakaChaturthi);
      } else {
        setVinayakList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch vinayak data:", error);
      setVinayakList([]);
    }
  };

  fetchVinayakData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="Vinayaka-container">
      <InnerNav />
      <div className="Vinayaka-content">
        <Zodiac />

        {/* Embedded Ekadashi Calendar */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Vinayaka Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
                <div>
                 
                  <p>{location}</p>
                </div>
                 <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="vin-controls">
                <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedVinayaka ? (
  <div className="vinayak-list">
    {vinayakList.length === 0 && (
      <p>No vinayak data available for selected year/location.</p>
    )}

    {vinayakList.map((item, idx) => (
      <div
        className="vinayak-item clickable"
        key={idx}
        onClick={() => setSelectedVinayaka(item)}
      >
        <img
          src="https://t4.ftcdn.net/jpg/02/86/51/73/360_F_286517396_X0AWrJ0uujHcxDuw331wGzsGyo0fSOpq.jpg"
          alt={item.title}
        />

        <div className="vinayak-details">
          <p className="vinayak-date">{item.date}</p>

          {/* <div className="tooltip-wrapper">
            <div className="vinayak-name">{item.title}</div>
            <span className="tooltip-text">
              {vinayakaChaturthiTooltips[item.title] || "No info available"}
            </span>
          </div> */}

<div className="vinayak-name">{item.title}</div>

          <p className="vinayak-phase">{item.muhurta}</p>
          <p className="vinayak-tithi">{item.tithiName}</p>
          <p className="vinayak-tithi">{item.duration}</p>
        </div>

        <div className="vinayak-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button
      className="back-btn"
      onClick={() => setSelectedVinayaka(null)}
    >
      ← Back
    </button>

    <h2>{selectedVinayaka.title}</h2>

    <img
      src="https://t4.ftcdn.net/jpg/02/86/51/73/360_F_286517396_X0AWrJ0uujHcxDuw331wGzsGyo0fSOpq.jpg"
      alt={selectedVinayaka.title}
    />

    <p><strong>Date:</strong> {selectedVinayaka.date}</p>
    <p><strong>Muhurta:</strong> {selectedVinayaka.muhurta}</p>
    <p><strong>Tithi:</strong> {selectedVinayaka.tithiName}</p>
    <p><strong>Duration:</strong> {selectedVinayaka.duration}</p>

    <p><strong>Lunar Detail:</strong> {selectedVinayaka.lunarDetail}</p>

    <p>
      <strong>Tithi Start:</strong>{" "}
      {formatTime(selectedVinayaka.tithiStart, timeFormat)}
    </p>

    <p>
      <strong>Tithi End:</strong>{" "}
      {formatTime(selectedVinayaka.tithiEnd, timeFormat)}
    </p>

    {vinayakaChaturthiTooltips[selectedVinayaka.title] && (
      <p>
        <strong>Significance:</strong>{" "}
        {vinayakaChaturthiTooltips[selectedVinayaka.title]}
      </p>
    )}
  </div>
)}

        </div>

         <section className="vinayaka-wrapper">
      <h1 className="vinayaka-title">Vinayaka Chaturthi</h1>
      <div className="vinayaka-texts">
        <p>
          Each lunar month in Hindu calendar has two Chaturthi Tithis. According to Hindu scriptures, Chaturthi Tithis belong to Lord Ganesha. The Chaturthi after Amavasya or new moon during Shukla Paksha is known as <strong>Vinayaka Chaturthi</strong>, and the one after Purnimasi or full moon during Krishna Paksha is known as 
          <Link to="/vrat/sankashti-chaturthi" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px', fontWeight: 'bold'}}>
            Sankashti Chaturthi
          </Link>
          
        </p>

        <p>
          Although Vinayaka Chaturthi fasting is done every month, the most significant Vinayaka Chaturthi falls in the month of <strong>Bhadrapada</strong>. Vinayaka Chaturthi during Bhadrapada month is known as <strong>Ganesha Chaturthi</strong>, which is celebrated by Hindus all over the world as the birthday of Lord Ganesha.
        </p>

        <p>
          Vinayaka Chaturthi is also known as <strong>Varad Vinayaka Chaturthi</strong>. "Varad" means asking God to fulfill any desire. Lord Ganesha blesses devotees with <strong>wisdom and patience</strong> who observe this fast. These virtues are known to be key for progress and success in life.
        </p>

        <p>
          <strong>Ganesha Puja</strong> on Vinayaka Chaturthi is performed during the <strong>afternoon</strong> or midday according to the Hindu calendar. The Muhurta for worshipping Lord Ganesha during this period is listed along with Vinayaka Chaturthi dates.
        </p>

        <h2>Location-based Vinayaka Chaturthi Days</h2>
        <p>
          It is important to understand that the fasting day for Vinayaka Chaturthi might differ for two cities, even within the same state. The fast is observed when <strong>Chaturthi Tithi prevails during midday</strong>. Due to varying sunrise and sunset timings, <strong>Vinayaka Chaturthi</strong> might sometimes fall on <strong>Tritiya Tithi</strong> for a specific location.
        </p>

        <p>
          As midday time depends on local sunrise and sunset, which are different for all cities, it is important to refer to a location-based Hindu calendar. Most online sources ignore this fact and publish a single list for all Indian cities, which might not be accurate for location-specific observances.
        </p>
      </div>
    </section>
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Vinayaka;
